import { Account } from "models/account"
import { WorkstreamData } from "models/workstream"
import request from "pmsa-polaris/api/request"

export type AccountResponse = Readonly<Account>

const workstreamsApi = {
  get: async () => request.get<Readonly<WorkstreamData>>(`/workstreams`),
}

export default workstreamsApi
